import { Controller } from "@hotwired/stimulus"

// Repeatable social links rows: add row (clone template), remove row.
export default class extends Controller {
  static targets = ["container", "template", "row"]

  addRow() {
    if (!this.hasTemplateTarget || !this.hasContainerTarget) return
    const clone = this.templateTarget.content.cloneNode(true)
    this.containerTarget.appendChild(clone)
  }

  removeRow(event) {
    const row = event.currentTarget.closest("[data-admin--social-links-target='row']")
    if (row) row.remove()
  }
}
